// スムーススクロール
const smoothScroll = () => {
  $('a[href^="#"]').on('click', e => {
    const speed = 600;
    const href = $(this).attr('href');
    const target = $(href == '#' || href == '' ? 'html' : href);
    const position = target.offset().top;
    $('body, html').delay(200).animate({scrollTop: position}, speed, 'swing');
    return false;
  });
};


// wow発動
const wowFunc = () => {
  new WOW().init();
};


// fancybox
const fancyBoxModal = ()=> {
  $('[data-fancybox]').fancybox({
    loop: true, // 複数画像表示時に最初と最後をループさせる
    transitionEffect: 'slide', // スライド時のアニメーション効果の種類
    transitionDuration: 1000, // スライド時のアニメーションにかかる時間
    animationEffect: 'fade', // 画像ズーム時のアニメーションの種類
    animationDuration: 800, // ズーム時のアニメーションにかかる時間
    infobar: true, // 上部にインフォメーションバーを表示するか否か
  });
}


// ボタンクリック関数
const btnClickFunc = () => {
  const $btns = $('.js-btn');

  $btns.on('click', e => {
    const btnTargetData = $(e.currentTarget).attr('data-btn');
    const btnAnimationData = $(e.currentTarget).attr('data-animation');
    const target = $(`[data-target = "${btnTargetData}"]`);
    const btnTargetGroupData = $(e.currentTarget).attr('data-btnGroup');
    const $sameBtns = $(`[data-btnGroup = "${btnTargetGroupData}"]`);
    const $sameTargets = $(`[data-targetGroup = "${btnTargetGroupData}"]`);

    if (btnAnimationData == 'slide') {
      $(e.currentTarget).toggleClass('js-active');
      target.slideToggle(300);
    } else if (btnAnimationData == 'class') {
      $(e.currentTarget).toggleClass('js-active');
      target.toggleClass('js-active');
    } else if (btnAnimationData == 'commonFade') {
      $sameBtns.toggleClass('js-active');
      target.fadeToggle(300);
    } else if (btnAnimationData == 'allClass') {
      $(e.currentTarget).toggleClass('js-active');
      $sameTargets.addClass('js-active');
    } else if (btnAnimationData == 'tab') {
      $sameBtns.not($(e.currentTarget)).removeClass('js-active');
      $(e.currentTarget).addClass('js-active');
      $sameTargets.removeClass('js-active');
      target.addClass('js-active');
    } else if (btnAnimationData == 'pageTop') {
      $('body, html').animate({
        scrollTop: 0
      }, 700);
      return false;
    } else {
      $(e.currentTarget).toggleClass('js-active');
    }
  });
};


// スクロール量感知する系の関数
const scrollFunc = () => {
  const windowHeight = $(window).innerHeight();
  const headerHeight = $('.js-header').innerHeight();
  const target = $('.js-scrollFadeObj');

  $(window).on('scroll', e => {
    const scrollCount = $(window).scrollTop();

    if (scrollCount >= (windowHeight - headerHeight)) {
      target.addClass('js-active');
    } else {
      target.removeClass('js-active');
    }
  });
};


const swiperSlider = () => {
  const topPageFvSlider = new Swiper('.topPageFvSec .swiper-container', {
    watchOverflow: true, // スライドが1枚しかなかったらスライダー機能をなくす
    autoplay: {
      delay: 6000, // 自動スライド・1スライド滞在時間
      disableOnInteraction: false, // ユーザーがスライド操作した後もautoplay続行
    },
    speed: 2000, // スライド切替スピード
    loop: true, // ループ(クローンスライドが作られる)
    spaceBetween: 0, // スライド間のmarginは0px
    observer: true, // 初期状態でスライダーが非表示でも動くようにする
    observeParents: true, // 初期状態でスライダーが非表示でも動くようにする
    effect: 'fade', // エフェクト
  });

  const topPageNewsSlider = new Swiper('.topPageNewsSec .swiper-container', {
    grabCursor: true, // スライダーを掴むカーソル表示
    watchOverflow: true, // スライドが1枚しかなかったらスライダー機能をなくす
    speed: 1000, // スライド切替スピード
    loop: false, // ループ(クローンスライドが作られる)
    spaceBetween: 40, // スライド間のmarginは40px
    slidesPerView: 3, // 3スライド表示
    observer: true, // 初期状態でスライダーが非表示でも動くようにする
    observeParents: true, // 初期状態でスライダーが非表示でも動くようにする
    effect: 'slide', // エフェクト
    preloadImages: false, // 画像の事前読み込みを禁止
    lazy: true, // 画像の読み込み遅延
    navigation: {
      prevEl: '.topPageNewsSec .swiper-button-prev', // 前へボタン
      nextEl: '.topPageNewsSec .swiper-button-next', // 次へボタン
    },
    breakpoints: {
      767: {
        spaceBetween: 20, // スライド間のmarginは20px
        slidesPerView: 1, // 1スライド表示
      }
    }
  });
}


// モジュールモーダル設定 http://www.humaan.com/modaal/
const moduleModal = function () {
  $('[class*="module_gallery"] a, [class*="module_column-col"] a.imgLink').modaal({
    type: 'image'
  });
};


// Class付与
const addCss = function () {
  $('.gc_main a > img').each(function () {
    $(this).parent('a[href$=".jpg"], a[href$=".png"], a[href$=".gif"], a[href$=".svg"]').addClass('imgLink');
    $(this).parent('a').addClass('icon-none');
  });
  $('.gc_main a > img.alignleft').each(function () {
    $(this).removeClass('alignleft').closest('a').wrap('<div class="alignleft"></div>');
  });
  $('.gc_main a > img.alignright').each(function () {
    $(this).removeClass('alignright').closest('a').wrap('<div class="alignright"></div>');
  });
  $('.gc_main a > img.aligncenter').each(function () {
    $(this).removeClass('aligncenter').closest('a').wrap('<div class="aligncenter"></div>');
  });
  $('[class*="module_column-col"] table:not([class])').each(function () {
    $(this).addClass('module_table-01');
  });
  $('.gc_main blockquote').each(function () {
    $(this).addClass('module_blockquote-01');
  });
  const notList = $('.gc_main ul:not([class]), .gc_main ol:not([class])');
  const notModule = $('.gm_slider, [class*="module_gallery-"] ul, ul[class*="module_"], ol[class*="module_"], .module_formList-01 ul');
  $(notList).not(notModule).each(function () {
    $(this).addClass('module_list-01');
  });
  const notIcon = $('[class*="module_card-"] a[target="_blank"], .global_contents p a.icon-none');
  $('.global_contents a:not([class])[target="_blank"]').not(notIcon).each(function () {
    $(this).addClass('icon-blank');
  });
  $('.gc_main .size-LL').each(function () {
    $(this).closest('span').css('display', 'block');
  });
};


// タグ追加・削除
const initHTML = function () {
  $('.gc_main p').each(function () {
    let txt = $(this).html();
    $(this).html(txt.replace(/&nbsp;/g, ''));
  });
  $('.module_table-01').wrap('<div class="module_table-wrap"></div>');
  $('[class*="module_column-col"] iframe[src*="www.youtube.com"]').each(function () {
    $(this).unwrap().wrap('<div class="moduleMovie"></div>');
  });
  $('[class*="module_column-col"] iframe[src*="www.google.com/maps/"]').each(function () {
    $(this).unwrap().wrap('<div class="moduleMap"></div>');
  });
};

$(function() {
  smoothScroll();
  wowFunc();
  fancyBoxModal();
  btnClickFunc();
  scrollFunc();
  swiperSlider();
  // moduleModal();
  addCss();
  initHTML();
});
